import { initializeApp } from "firebase/app";
import {
  getAuth,
  onAuthStateChanged,
  type User,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAiHhZEODqzRrug4zSRv2_gtOb7cQTT_NM",
  authDomain: "junk-guys-217ac.firebaseapp.com",
  projectId: "junk-guys-217ac",
  storageBucket: "junk-guys-217ac.firebasestorage.app",
  messagingSenderId: "1091375818738",
  appId: "1:1091375818738:web:2715eb94ab6704a5402d6b",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(
  app,
  "https://junk-guys-217ac-default-rtdb.firebaseio.com/",
);

export default defineNuxtPlugin((nuxtApp) => {
  const user = useState<User | null>("firebaseUser", () => null);

  // Set persistence with fallback
  setPersistence(auth, browserLocalPersistence).catch((error) => {
    console.warn(
      "Local persistence disallowed (likely privacy settings), trying session persistence.",
      error,
    );
    // Fallback to session persistence? Or just let it fail but don't crash.
    // Note: We need import browserSessionPersistence if we use it.
    // For now, just catching the error prevents the "Uncaught" message.
  });

  // Create a Promise to wait for auth to settle
  let resolveAuth: (value: unknown) => void;
  const authReady = new Promise((resolve) => {
    resolveAuth = resolve;
  });

  // Listen for auth state changes
  onAuthStateChanged(auth, (currentUser) => {
    user.value = currentUser;
    resolveAuth(true); // Signal that auth state is determined
  });

  nuxtApp.provide("auth", auth);
  nuxtApp.provide("db", db);
  nuxtApp.provide("rtdb", rtdb);
  nuxtApp.provide("authReady", authReady);
});
